export class DownloadTrackerHelper {
}
/**
 * Get the number of user sessions where download occurred
 * @param localStorageKey the static key to access where download count is stored
 */
DownloadTrackerHelper.getDownloadCount = (localStorageKey) => {
    return parseInt(localStorage.getItem(localStorageKey) || '0', 10);
};
/**
 * Handle a new click of the download button and increment the session-distinct download count if necessary
 * @param localStorageKey the static key to access where download count is stored
 * @param isAuthenticated whether the Rev user is logged in or not
 */
DownloadTrackerHelper.handleDownloadClick = (localStorageKey, isAuthenticated) => {
    if (!isAuthenticated) {
        const totalDownloads = DownloadTrackerHelper.getDownloadCount(localStorageKey);
        localStorage.setItem(localStorageKey, `${totalDownloads + 1}`);
    }
};
